import type { LabDataMock, LabOrderIncludedOrder, LabOrderIncludedResource } from '@type/lab.type'
import type { OrderLabTestIncluded } from '@type/order.type'
import { buildOrderTestLines, type IncludedOrderLike, type OrderTestLine } from '@util/testCatalogue'

/** One test of a lab order; `performedAt === 'outside'` lines are referred out and resulted by upload. */
export type PlacedLine = OrderTestLine

export function buildPlacedLines(data: LabDataMock, included: LabOrderIncludedResource[] | undefined): PlacedLine[] {
  if (data.type === 'lab_order') {
    const childOrders = (included ?? []).filter((x): x is LabOrderIncludedOrder => x.type === 'order')
    return buildOrderTestLines({
      included: childOrders as IncludedOrderLike[],
      orderRefs: data.relationships.orders?.data ?? [],
      outsideNames: data.attributes.outside_names ?? [],
      resolveLabel: child => {
        const labTestId = child?.attributes?.orderable_id
        if (labTestId == null) return undefined
        return included?.find(
          (x): x is OrderLabTestIncluded => x.type === 'lab_test' && String(x.id) === String(labTestId)
        )?.attributes.name
      },
      status: data.attributes.status,
      testNames: data.attributes.test_names ?? []
    })
  }

  const testRefId = data.relationships.orderable.data?.id
  const labTest = included?.find((x): x is OrderLabTestIncluded => x.type === 'lab_test' && x.id === testRefId)
  return [
    {
      key: data.id,
      label: labTest?.attributes.name ?? 'Lab test',
      lineStatus: String(data.meta?.status ?? 'pending'),
      orderId: data.id,
      performedAt: 'our_lab'
    }
  ]
}

/** Lines the patient does at an outside lab (what the referral slip lists and what can be uploaded for). */
export const outsidePlacedLines = (lines: PlacedLine[]) =>
  lines.filter(line => line.performedAt === 'outside' && line.lineStatus.toLowerCase() !== 'cancelled')

export function orderTitleNumber(rawId: string) {
  const n = Number.parseInt(rawId, 10)
  if (!Number.isNaN(n)) return String(n).padStart(7, '0')
  return rawId
}
export function createLabResultAttachmentPayload(signed_id: string, test_name: string) {
  return {
    data: {
      type: 'lab_result',
      attributes: {
        attachment_signed_id: signed_id,
        test_name
      }
    }
  } as const
}
